import { HERO, CIVIL3D, APPLIED } from '../content/copy';
import { Link } from '../hooks/useRouter';
import PerceptionStack from '../components/PerceptionStack';
import HeroScene from '../components/HeroScene';
import CivilWorkspace from '../components/CivilWorkspace';
import BuiltWith from '../components/BuiltWith';
import { DOMAIN_VISUALS } from '../content/visuals';

export default function Home() {
  return (
    <>
      <Hero />
      <ProductFeature />
      <PerceptionStack />
      <AppliedPhysicalAI />
    </>
  );
}

function Hero() {
  return (
    <section className="bv-hero">
      <div className="bv-wrap bv-hero-grid">
        <div className="bv-hero-copy">
          <p className="bv-eyebrow">{HERO.eyebrow}</p>
          <h1 className="bv-h1">{HERO.title}</h1>
          <p className="bv-lead">{HERO.support}</p>
          <div className="bv-hero-btns">
            <Link to={HERO.primaryCta.to} className="bv-btn bv-btn-solid">
              {HERO.primaryCta.label} <span aria-hidden="true">→</span>
            </Link>
            <Link to={HERO.secondaryCta.to} className="bv-btn bv-btn-ghost">
              {HERO.secondaryCta.label}
            </Link>
          </div>
          <BuiltWith />
        </div>
        <HeroScene />
      </div>
    </section>
  );
}

function ProductFeature() {
  return (
    <section className="bv-product-feature" aria-labelledby="home-civil-title">
      <div className="bv-wrap bv-product-split">
        <div className="bv-product-copy">
          <p className="bv-eyebrow">{CIVIL3D.eyebrow}</p>
          <h2 id="home-civil-title" className="bv-display-product">{CIVIL3D.name}</h2>
          <p className="bv-product-statement">{CIVIL3D.tagline}</p>
          <div className="bv-product-workflow" aria-label="civil3d workflow">
            {CIVIL3D.process.map((step, i) => (
              <span key={step}>
                <b>{i + 1}</b>
                {step}
                {i < CIVIL3D.process.length - 1 && <i aria-hidden="true">→</i>}
              </span>
            ))}
          </div>
          <p className="bv-outcomes-label">Key outcomes</p>
          <ul className="bv-outcome-list">
            {CIVIL3D.homeOutcomes.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <Link to="/civil3d" className="bv-btn bv-btn-solid">
            Explore civil3d <span aria-hidden="true">→</span>
          </Link>
        </div>
        <CivilWorkspace />
      </div>
    </section>
  );
}

function AppliedPhysicalAI() {
  return (
    <section className="bv-applied-section" aria-labelledby="home-caps-title">
      <div className="bv-wrap">
        <header className="bv-applied-heading">
          <p className="bv-eyebrow">{APPLIED.eyebrow}</p>
          <h2 id="home-caps-title" className="bv-h2">{APPLIED.title}</h2>
          <p className="bv-lead">From buildings to robots to industrial systems — the same perception layer, applied where the physical world is the product.</p>
        </header>
        <div className="bv-applied-grid">
          {APPLIED.items.map((item) => {
            const visual = DOMAIN_VISUALS[item.id];
            return (
              <article key={item.id} className="bv-applied-card">
                <div className="bv-applied-media">
                  <img
                    src={visual.src}
                    srcSet={visual.srcSet}
                    sizes="(max-width: 640px) 92vw, (max-width: 1100px) 44vw, 260px"
                    alt={visual.alt}
                    width="720"
                    height="1080"
                    loading="lazy"
                  />
                </div>
                <div className="bv-applied-copy">
                  <h3>{item.title}</h3>
                  <p>{item.body}</p>
                  <Link to={item.to} className="bv-icon-btn" aria-label={`Open ${item.title}`}>
                    <span aria-hidden="true">→</span>
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
